module.exports = __webpack_public_path__ + "static/media/diagonal.833c7d55.svg";